module.exports = __webpack_public_path__ + "static/matbuu-detail3-c8193db02ffd1c7a4d9c8bc9969c43ba.png";